// Wire star-input cho review form (3.7 shop + 3.8 product). Click sao N → set
// hidden eval_N=N + fill sao 1..N; hover preview; badge 必須→OK khi đã chọn.
// Idempotent: chạy 1 lần cho mọi [data-eval-axis] trên trang.
(function () {
  'use strict';

  const GOLD = '#ff8a1c';

  function paint(widget, value) {
    widget.querySelectorAll('[data-star]').forEach((btn) => {
      const n = parseInt(btn.dataset.star, 10);
      // n<=value: cam; else để trống → fallback class text-ink-grayLine (xám).
      btn.style.color = n <= value ? GOLD : '';
    });
  }

  function initAxis(axis) {
    const widget = axis.querySelector('[data-star-widget]');
    const hidden = axis.querySelector('input[type=hidden]');
    const badge = axis.querySelector('[data-eval-badge]');
    if (!widget || !hidden) return;

    const setBadge = () => {
      if (!badge) return;
      const ok = parseInt(hidden.value, 10) > 0;
      badge.textContent = ok ? 'OK' : '必須';
      // 必須 đỏ, OK xanh (mirror forminput_required / forminput_OK).
      badge.style.backgroundColor = ok ? '#01b245' : '#d21e28';
    };

    widget.querySelectorAll('[data-star]').forEach((btn) => {
      const n = parseInt(btn.dataset.star, 10);
      btn.addEventListener('mouseenter', () => paint(widget, n));
      btn.addEventListener('click', () => {
        hidden.value = String(n);
        paint(widget, n);
        setBadge();
      });
    });
    widget.addEventListener('mouseleave', () => paint(widget, parseInt(hidden.value, 10) || 0));

    paint(widget, parseInt(hidden.value, 10) || 0);
    setBadge();
  }

  function boot() {
    document.querySelectorAll('[data-eval-axis]').forEach(initAxis);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
